export const resistance = (threshold) => (distance) =>
  (1 - 1 / ((distance * 0.55) / threshold + 1)) * threshold;
